export const BESSIcon = ({
  width = '289',
  height = '237',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width ?? '289'}
      height={height ?? '237'}
      viewBox="0 0 289 237"
      style={{ paddingLeft: '1px' }}
      fill="none"
    >
      <path
        d="M218 39V10H113.5M113.5 227H10V10H113.5M113.5 227V10M113.5 227H207M207 227H279V91H266M207 227V91H218M218 91V65H266V91M218 91H266M228.5 123.5H257.5M228.5 159H257.5M228.5 194H257.5M169.5 78.5L151.5 115.5H180L163 147.5M65 78.5L47.5 115.5H76.5L59.5 147.5"
        stroke="currentColor"
        strokeWidth="20"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
